/** Включены ли уведомления в приложении (независимо от Chrome Notification.permission). */
const PREFS_KEY = 'duvpost_chat_in_app_notify_v1';

/** Старый ключ — только для одноразовой миграции в PREFS_KEY. */
const LEGACY_NOTIFY_KEY = 'duvpost_chat_browser_notify';

/**
 * Разрешение в Chrome может остаться «granted», но показывать системные уведомления
 * мы должны только если пользователь явно включил это в настройках.
 */
export function readChatBrowserNotifyEnabled(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const v = window.localStorage.getItem(PREFS_KEY);
    if (v !== null) {
      return v === '1';
    }
    return migrateLegacyToV1Once();
  } catch {
    return false;
  }
}

/** Одноразово переносим значение из старой схемы; дальше работает только PREFS_KEY. */
function migrateLegacyToV1Once(): boolean {
  const legacy = window.localStorage.getItem(LEGACY_NOTIFY_KEY);
  let enabled = false;
  if (legacy === '1') {
    enabled = true;
  } else if (legacy === '0') {
    enabled = false;
  } else {
    // Раньше при null после миграции v2 часто считалось «вкл» — при переносе трактуем как выкл,
    // пользователь сможет снова включить в настройках.
    enabled = false;
  }
  try {
    window.localStorage.setItem(PREFS_KEY, enabled ? '1' : '0');
  } catch {
    /* */
  }
  return enabled;
}

export function writeChatBrowserNotifyEnabled(enabled: boolean): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(PREFS_KEY, enabled ? '1' : '0');
  } catch {
    /* private mode и т.п. */
  }
}
